import React from "react";
import {
  Container,
  Typography,
  Link,
  Divider,
  Stack,
} from "@mui/material";

/**
 * Footer esteso con disclaimer, logo, info servizio, chat, assistenza, cookie, privacy e termini.
 * Tutte le sezioni sono ispirate al testo fornito e pensate per chiarezza e accessibilità.
 */
function Footer() {
  return (
    <footer
      style={{
        padding: "2rem 0 1rem 0",
        backgroundColor: "#fff",
        marginTop: "auto",
        flexShrink: 0,
      }}
    >
      <Container maxWidth="md">
        {/* Disclaimer */}
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ mb: 2 }}
        >
          Il contenuto fornito su questo sito web non deve essere considerato un
          consulto medico. Per qualsiasi domanda, consultare un medico.
        </Typography>
        <Divider sx={{ my: 2 }} />
        {/* Link utili allineati orizzontalmente */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Link href="/about" underline="hover" color="inherit">
            Info sul servizio
          </Link>
          <Link
            href="https://forms.gle/XEu9NzkhrnjGJevn7"
            underline="hover"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Segnala un problema
          </Link>
          <Link
            href="https://www.iubenda.com/privacy-policy/41207377"
            underline="hover"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
          <Link
            href="https://www.iubenda.com/privacy-policy/41207377/cookie-policy"
            underline="hover"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </Link>
          <Link
            href="https://questoecheto.it/disclaimer"
            underline="hover"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
          >
            Disclaimer
          </Link>
        </Stack>
        <Typography
          variant="caption"
          color="textSecondary"
          align="center"
          display="block"
        >
          &copy; {new Date().getFullYear()} Questo è Cheto
        </Typography>
      </Container>
    </footer>
  );
}

export default Footer;
